import { getDimensionFor, getLeftOrTop } from "./direction-helpers"

import { nullifyTransforms } from "./helpers"

const moveToIndexFor = (flexyInstance, isPrev = false) => {
  let p = isPrev ? 1 : -1

  let resultTarget =
    (Math.round(
      (flexyInstance.state.positionX * 100) /
        getDimensionFor(
          nullifyTransforms(
            flexyInstance.sliderContainer.firstElementChild,
            flexyInstance.options.nullifyTransformEl
          ),
          flexyInstance
        ) /
        100
    ) *
      100 *
      getDimensionFor(
        nullifyTransforms(
          flexyInstance.sliderContainer.firstElementChild,
          flexyInstance.options.nullifyTransformEl
        ),
        flexyInstance
      )) /
      100 +
    getDimensionFor(
      nullifyTransforms(
        flexyInstance.sliderContainer.firstElementChild,
        flexyInstance.options.nullifyTransformEl
      ),
      flexyInstance
    ) *
      p

  flexyInstance.state = {
    ...flexyInstance.state,
    positionTarget: resultTarget,
  }
}

export const mountArrowsListeners = (flexyInstance) => {
  flexyInstance.options.leftArrow &&
    flexyInstance.options.leftArrow.addEventListener("click", (e) => {
      e.preventDefault()
      moveToIndexFor(flexyInstance, true)
    })

  flexyInstance.options.rightArrow &&
    flexyInstance.options.rightArrow.addEventListener("click", (e) => {
      e.preventDefault()
      moveToIndexFor(flexyInstance)
    })
}
